import React from 'react';
import { TTemplate } from '@/helpers/createTemplate';
import Card from '../Card';
import {
  FlexFeatureWrapper,
  FlexFeatureTitleWrapper,
  FlexFeatureCardWrapper,
  HeadingSlogan,
  SpanSlogan,
  ImageMascot,
} from '../styles/Featured.styles';
import baseTemplate from './template.default';
import ninja from '../../../../../../assets/questbet/images/homeFeaturedRacing/sport-ninja.png';

const template: TTemplate = {
  wrapper: <FlexFeatureWrapper />,
  feature: (
    <FlexFeatureTitleWrapper>
      <HeadingSlogan>
        Featured
        <SpanSlogan>Race</SpanSlogan>
      </HeadingSlogan>
      <ImageMascot src={ninja} />
    </FlexFeatureTitleWrapper>
  ),
  card: (
    <FlexFeatureCardWrapper>
      <Card />
    </FlexFeatureCardWrapper>
  ),

  ...(baseTemplate?.first as TTemplate),
};

export default template;
